import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

const showSuccessToast = (msg) => {
    toastr.options = {
        positionClass : "toast-bottom-right",
        timeOut: "3000",
    }

    toastr.success(msg, "Sukses")
}

const showErrorToast = (msg) => {
    toastr.options = {
        positionClass : "toast-bottom-right",
        timeOut: "3000",
    }

    toastr.warning(msg, "Error")
}

export { showSuccessToast, showErrorToast }